// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import EventController from "./event_controller"
application.register("event", EventController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import DojoController from "./dojo_controller"
application.register("dojo", DojoController)
